import React, { useState } from 'react';

import { useTranslation } from '../../../../../../../hooks';
import { T } from '../../../../../../../constants';

import './style.scss';

export enum GamesTabKey {
  CurrentGame = 'currentGame',
  AllGames = 'allGames',
}
interface WinnersTab {
  key: GamesTabKey;
  label: string;
}
interface WinnersTabsProps {
  tabs?: WinnersTab[];
  activeTab?: GamesTabKey;
  onChange?: (tab: GamesTabKey) => void;
}

const DEFAULT_TABS: WinnersTab[] = [
  { key: GamesTabKey.CurrentGame, label: T.CURRENT_GAME },
  { key: GamesTabKey.AllGames, label: T.ALL_GAMES },
];

export const GamesTabs: React.FC<WinnersTabsProps> = ({
  tabs = DEFAULT_TABS,
  activeTab,
  onChange,
}) => {

  const t = useTranslation();

  const [internalActive, setInternalActive] = useState<GamesTabKey>(
    activeTab ?? tabs[0]?.key
  );

  const current = activeTab ?? internalActive;

  const activeIndex = Math.max(0, tabs.findIndex(({ key }) => key === current));

  const handleClick = (key: GamesTabKey) => {
    if (activeTab === undefined) setInternalActive(key);
    onChange?.(key);
  };

  return (
    <div
      className="winnersTabs"
      style={{
        ['--wt-count' as string]: tabs.length,
        ['--wt-translate' as string]: `${activeIndex * 100}%`,
      } as React.CSSProperties}
    >
      {tabs.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          className={`winnersTab ${current === key ? 'winnersTabActive' : ''}`}
          onClick={() => handleClick(key)}
        >
          <span className="winnersTabLabel">{t(label)}</span>
        </button>
      ))}
      <span className="winnersTabIndicator" />
    </div>
  );
};

